import { useState } from "react";
import CertificateCard from "../components/CertificateCard";
import CertificateModal from "../components/CertificateModal";
import SectionHeader from "../components/SectionHeader";
import Seo from "../components/Seo";
import { certificates } from "../content";
import { breadcrumbSchema, certificateListSchema } from "../lib/structuredData";

function CertificatesListPage() {
  const [activeCertificate, setActiveCertificate] = useState(null);

  return (
    <section id="certificates">
      <Seo
        description={`${certificates.length} professional certificates earned by Robert Doe, covering web development, security, Android, Java, and more.`}
        jsonLd={[
          certificateListSchema(certificates),
          breadcrumbSchema([{ name: "Home", path: "/" }, { name: "Certificates", path: "/certificates" }]),
        ]}
        path="/certificates"
        title="Certificates - Robert Doe"
      />
      <p className="eyebrow">Continuing education</p>
      <SectionHeader title="Courses & certificates" />
      <p className="page-deck">An archive of courses supporting my development across software engineering, security, and design.</p>
      <div className="certificates-grid">
        {certificates.map((cert, index) => (
          <CertificateCard
            cert={cert}
            key={cert.slug ?? `${cert.title}-${index}`}
            onSelect={setActiveCertificate}
          />
        ))}
      </div>

      <CertificateModal cert={activeCertificate} onClose={() => setActiveCertificate(null)} />
    </section>
  );
}

export default CertificatesListPage;
